
import { defineComponent, PropType } from 'vue'
import { iCalendar } from '../../CalendarManagement'
import Calendar from 'primevue/calendar'
import calendarManagementDetailFormDescriptor from './CalendarManagementDetailFormDescriptor.json'

export default defineComponent({
    name: 'calendar-management-detail-form',
    components: { Calendar },
    props: { propCalendar: { type: Object as PropType<iCalendar | null> }, generateButtonVisible: { type: Boolean }, generateButtonDisabled: { type: Boolean } },
    emits: ['generateCalendarClicked'],
    data() {
        return {
            calendarManagementDetailFormDescriptor,
            calendar: null as iCalendar | null,
            calendarNameDirty: false,
            startDateDirty: false,
            endDateDirty: false
        }
    },
    computed: {
        canManageCalendar(): boolean {
            return (this.$store.state as any).user.functionalities.includes('ManageCalendar')
        },
        readonly(): boolean {
            return this.calendar?.calendarId !== undefined
        },
        nameHelp(): string {
            return (this.calendar?.calendar.length ?? '0') + ' / ' + calendarManagementDetailFormDescriptor.nameMaxLength
        },
        typeHelp(): string {
            return (this.calendar?.calType.length ?? '0') + ' / ' + calendarManagementDetailFormDescriptor.typeMaxLength
        }
    },
    watch: {
        propCalendar() {
            this.loadCalendar()
        }
    },
    created() {
        this.loadCalendar()
    },
    methods: {
        loadCalendar() {
            this.calendar = this.propCalendar as iCalendar
        },
        generateCalendar() {
            this.$emit('generateCalendarClicked')
        }
    }
})
